/**
 * Phone number formatting helpers.
 *
 * Source data may store numbers in various shapes ("+91 9393945252",
 * "+919393945252", "+91 95335 61060"). For consistent display across
 * the site we always render Indian mobile numbers as:
 *
 *      +91 XXXXX XXXXX
 *
 * `tel:` links strip whitespace so they continue dialing the full digits.
 */

const stripDigits = (value) => (value || "").replace(/[^\d]/g, "");

/**
 * Format an Indian phone number for display as `+91 XXXXX XXXXX`.
 * Falls back to the original value if the input isn't a 10-digit Indian mobile.
 */
export const formatIndianPhone = (raw) => {
  if (!raw) return "";
  const digits = stripDigits(raw);
  // Take the last 10 digits as the mobile number (handles inputs with/without 91 prefix)
  const last10 = digits.slice(-10);
  if (last10.length !== 10) return raw;
  return `+91 ${last10.slice(0, 5)} ${last10.slice(5)}`;
};

/** Return a tel-safe version: `+91XXXXXXXXXX`. */
export const telHref = (raw) => {
  if (!raw) return "";
  const digits = stripDigits(raw);
  const last10 = digits.slice(-10);
  if (last10.length !== 10) return `tel:${raw}`;
  return `tel:+91${last10}`;
};
